import { createSelector } from 'reselect';
import { NAMESPACE } from './constants';
import { initialState } from './reducer';

const selectInitWebchatDomain = state => state[NAMESPACE] || initialState;

const selectTopic = () =>
    createSelector(selectInitWebchatDomain, state => state.topic);

const selectWebchatPath = () =>
    createSelector(selectInitWebchatDomain, state => state.webchatPath);

const selectBotName = () =>
    createSelector(selectInitWebchatDomain, state => state.botName);

const selectWebchatAvailable = () =>
    createSelector(selectInitWebchatDomain, state => state.webchatAvailable);

const selectWebchatUserData = () =>
    createSelector(selectInitWebchatDomain, state => state.webchatUserData);

export {
    selectTopic,
    selectWebchatPath,
    selectBotName,
    selectWebchatAvailable,
    selectWebchatUserData,
};
